<template>
  <div class="row">
    <div class="col-12 col-xl-5 order-1 order-xl-0">
      <b-card no-body class="shadow border overflow-hidden mt-3 mt-xl-0">
        <b-card-header :header-class="'text-center text-md-left rounded-top'">
          {{ $t('Photo Gallery') }}
        </b-card-header>
        <b-card-body class="p-3 rounded-bottom">
          <div class="row">
            <div v-for="image in listing.images" :key="image.id" class="col-12 col-md-2 col-xl-4 my-1 image-wrapper">
              <img :src="listingImageUrl(image.image)" class="img-fluid image w-100" alt="Work Image">
              <span class="delete-icon position-absolute d-block" @click="confirmDelete(image)">
                <font-awesome-icon :icon="'times-circle'" />
              </span>
              <span class="edit-icon position-absolute d-block" @click="edit(image)">
                <font-awesome-icon :icon="'edit'" />
              </span>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
    <div class="col-12 col-xl-7 order-0 order-xl-1">
      <b-card ref="imageEditor" no-body class="shadow border overflow-hidden">
        <b-card-header :header-class="'text-center text-md-left rounded-top'">
          {{ $t('Add Photos') }}
        </b-card-header>
        <b-card-body class="p-3 rounded-bottom">
          <b-form v-if="!busy" :class="'p-2'">
            <b-form-group>
              <custom-file-upload
                v-b-tooltip.hover.bottom="uploadTooltip"
                :type="'listingImage'"
                :max-size="maxSize"
                :listing-image="editImage"
                @cancel="editImage=null"
                @state="passState"
              />
            </b-form-group>
          </b-form>
        </b-card-body>
      </b-card>
      <b-modal id="delete-image" centered @ok="removeImage">
        <template #modal-header="{ close }">
          <h5 class="modal-title">
            {{ $t('Coverage area') }}
          </h5>
          <b-button class="close" @click.stop="close">
            <font-awesome-icon icon="times" />
          </b-button>
        </template>
        <div>{{ $t('Are you sure you want to remove this image?') }}</div>
        <template #modal-footer="{ ok, cancel }">
          <b-button size="sm" variant="outline-secondary" @click="cancel()">
            {{ $t('Cancel') }}
          </b-button>
          <b-button size="sm" variant="primary" @click="ok()">
            {{ $t('OK') }}
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import CustomFileUpload from "@/components/form/CustomFileUpload";
import userDevice from "@/imports/mixins/userDevice";
import VueScrollTo from "vue-scrollto";

const IMAGE_CACHE_BASE = process.env.VUE_APP_IMAGE_CACHE_URL;
const LISTING_IMAGE_FILTER = 'company_profile_thumbnail_large/images/installer/work/'

export default {
  name: "ListingImages",
  components: {CustomFileUpload},
  mixins: [userDevice],
  props: ['value'],
  data: function() {
    return {
      disableSave:false,
      busy: false,
      listing: this.value,
      images: null,
      imgToDelete:null,
      editImage: null,
    }
  },
  computed: {
    maxSize: function() {
      return this.$store.state.MAX_UPLOAD_SIZE;
    },
    uploadTooltip: function() {
      if (this.isDesktop) {
        return {
          title: this.$t('uploadToolTip'),
          html: true,
          placement: 'top',
        }
      }
      return undefined;
    },
  },
  methods: {
    listingImageUrl: function(path) {
      return IMAGE_CACHE_BASE + LISTING_IMAGE_FILTER + path;
    },
    removeImage: function() {
      const images = this.listing.images.filter(image => image.id !== this.imgToDelete.id);
      this.listing = {...this.listing, images};
      this.$api.company.removeImage(this.imgToDelete.id).then(() => {
        this.imgToDelete = null;
      });
    },
    passState: function(state) {
      this.$emit('state', state);
    },
    confirmDelete(image) {
      this.imgToDelete = image;
      this.$bvModal.show('delete-image');
    },
    edit: function(image) {
      this.editImage = image;
      VueScrollTo.scrollTo(this.$refs.imageEditor, 500, {
        offset:-150,
      });
    }
  },
  watch: {
    listing: {
      handler: function(value) {
        this.$emit('input', value);
        this.$emit('state', false);
      },
      deep: true
    },
    editImage: function(value) {
      if (value === null) {
        this.$emit('state', true);
      } else {
        this.$emit('state', false);
      }
    },
    value: function(value) {
      this.listing = value;
    },
  },
}
</script>

<style scoped lang="scss">
.image-wrapper {
  position: relative;
  border: 15px solid $white;

  .delete-icon {
    color: $black;
    background-color: $white;
    border-radius: 3px;
    padding: 2px 3px;
    top: 10px;
    right: 25px;
    font-size: 20px;
    cursor: pointer;
    height: 26px;
    width: 26px;
    line-height: 1;
    overflow: hidden;
    .svg-inline-fa {
      height: 20px !important;
      width: 20px !important;
    }
  }
  .edit-icon {
    color: $black;
    background-color: $white;
    border-radius: 3px;
    padding: 2px 2px;
    top: 10px;
    left: 25px;
    font-size: 20px;
    cursor: pointer;
    height: 26px;
    width: 26px;
    line-height: 1;
    overflow: hidden;
    .svg-inline-fa {
      height: 20px !important;
      width: 20px !important;
    }
  }
}

.image-tag-wrapper {
  overflow: hidden;

  .image {
    max-height: 165px;
  }

  @include media-breakpoint-down(sm) {
    max-width: 150px;
  }
}

</style>
